import React from 'react';
import ProductPageTemplate from '../../components/ProductPageTemplate';
import { roPlants } from '../../mock/mockData';

const ROPlant5000LPH = () => {
  const productData = roPlants.find(p => p.id === 'ro-5000');
  return <ProductPageTemplate productData={productData} />;
};

export default ROPlant5000LPH;